import * as React from "react";
import {PromoBlockType} from "../../models/types";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

/** PROMO BLOCK BOX */

interface PromoBlockBoxProps {
  /** TYTUŁ PROMO-BLOCKA */
  promoBlockTitle: string

  /** TEXT W PROMO-BLOCKU */
  promoBlockText: string

  /** TEKST PRZYCISKU */
  promoBlockButtonText: string

  /** FUNKCJA PRZYCISKU */
  promoBlockButtonOnClick: () => any

  /** LINK PROMO BLOCKA => OTWIERANY W NOWYK OKNIE */
  promoBlockLink: string

  /** PADDING-TOP, JEŚLI CHCEMY INNY NIŻ DEFAULT: 50 */
  paddingTop?: number

  /** PADDING-BOTTOM, JEŚLI CHCEMY INNY NIŻ DEFAULT: 50 */
  paddingBottom?: number
}

/** PROMO BLOCK GRAY BOX */

const PromoBlockGrayBox = (props: PromoBlockBoxProps) => {
  const {promoBlockTitle,promoBlockText,promoBlockButtonText,promoBlockButtonOnClick,promoBlockLink,paddingTop,paddingBottom} = props;
  return (
    <PromoBlockContainerWrapper className="ptb-50" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <div className="container">
        <div className="promo-box gray-bg border-box">
          <div className="promo-info">
            <PromoBlockH2 className="text-extrabold text-uppercase">{promoBlockTitle}</PromoBlockH2>
            <p>
              {promoBlockText}
            </p>
          </div>
          <div className="promo-btn">
            <a href={promoBlockLink} onClick={promoBlockButtonOnClick} target="_blank" className="btn btn-lg waves-effect waves-light">{promoBlockButtonText}</a>
          </div>
        </div>
      </div>
    </PromoBlockContainerWrapper>
  )
};

/** PROMO BLOCK WHITE BOX */

const PromoBlockWhiteBox = (props: PromoBlockBoxProps) => {
  const {promoBlockTitle,promoBlockText,promoBlockButtonText,promoBlockButtonOnClick,promoBlockLink,paddingTop,paddingBottom} = props;
  return (
    <PromoBlockContainerWrapper className="ptb-50" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <div className="container">
        <div className="promo-box border-box">
          <div className="promo-info">
            <PromoBlockH2 className="text-extrabold text-uppercase">{promoBlockTitle}</PromoBlockH2>
            <p>
              {promoBlockText}
            </p>
          </div>
          <div className="promo-btn">
            <a href={promoBlockLink} onClick={promoBlockButtonOnClick} target="_blank" className="btn btn-lg waves-effect waves-light">{promoBlockButtonText}</a>
          </div>
        </div>
      </div>
    </PromoBlockContainerWrapper>
  )
};

/** PROMO BLOCK ICON BOX */

const PromoBlockIconBox = (props: PromoBlockBoxProps) => {
  const {promoBlockTitle,promoBlockText,promoBlockButtonText,promoBlockButtonOnClick,promoBlockLink,paddingTop,paddingBottom} = props;
  return (
    <PromoBlockContainerWrapper className="gray-bg ptb-50" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <div className="container">
        <div className="promo-box white-bg border-box">
          <div className="promo-info">
            <i className="fa fa-thumbs-o-up promo-icon circle"></i>
            <PromoBlockH2 className="text-extrabold text-uppercase">{promoBlockTitle}</PromoBlockH2>
            <p>{promoBlockText}</p>
          </div>
          <div className="promo-btn">
            <a href={promoBlockLink} onClick={promoBlockButtonOnClick} target="_blank" className="btn btn-lg waves-effect waves-light">{promoBlockButtonText}</a>
          </div>
        </div>
      </div>
    </PromoBlockContainerWrapper>
  )
};

/** PROMO BOX THEME COLOR BOX */

const PromoBlockThemeColorBox = (props: PromoBlockBoxProps) => {
  const {promoBlockTitle,promoBlockText,promoBlockButtonText,promoBlockButtonOnClick,promoBlockLink,paddingTop,paddingBottom} = props;
  return (
    <PromoBlockContainerWrapper className="ptb-50" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <div className="container">
        <div className="promo-box brand-bg mb-50">
          <div className="promo-info">
            <span className="white-text text-uppercase">{promoBlockText}</span>
            <PromoBlockH2 className="white-text text-uppercase text-bold no-margin">{promoBlockTitle}</PromoBlockH2>
          </div>
          <div className="promo-btn">
            <a href={promoBlockLink} onClick={promoBlockButtonOnClick} target="_blank" className="btn btn-lg white waves-effect waves-grey">{promoBlockButtonText}</a>
          </div>
        </div>
      </div>
    </PromoBlockContainerWrapper>
  )
};

/** PROMO BOX FULL WIDTH THEME COLOR BOX */

const PromoBlockFullWidthThemeColorBox = (props: PromoBlockBoxProps) => {
  const {promoBlockTitle,promoBlockText,promoBlockButtonText,promoBlockButtonOnClick,promoBlockLink,paddingTop,paddingBottom} = props;
  return (
    <PromoBlockContainerWrapper className="full-width promo-box brand-bg ptb-50" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <div className="container">
        <div className="col-md-12">
          <div className="promo-info">
            <span className="white-text text-uppercase">{promoBlockText}</span>
            <PromoBlockH2 className="white-text text-bold text-uppercase no-margin">{promoBlockTitle}</PromoBlockH2>
          </div>
          <div className="promo-btn">
            <a href={promoBlockLink} onClick={promoBlockButtonOnClick} target="_blank" className="btn white waves-effect waves-grey">{promoBlockButtonText}</a>
          </div>
        </div>
      </div>
    </PromoBlockContainerWrapper>
  )
};

/** STYLES */

const PromoBlockContainerWrapper: any = styled.div`
  ${(props: any) => typeof props.paddingTop === 'number' && `padding-top: ${props.paddingTop}px !important;`}
  ${(props: any) => typeof props.paddingBottom === 'number' && `padding-bottom: ${props.paddingBottom}px !important;`}
  div.container {
    width: 100% !important;
    max-width: 1170px !important;
  }
`;

const PromoBlockH2 = styled.h2`
  line-height: 22px; 
`;

/** PROMO BLOCK */

interface PromoBlockProps {
  /** TYP PROMO BLOCKA */
  promoBlockType: PromoBlockType

  /** TYTUŁ PROMO-BLOCKA */
  promoBlockTitle: string

  /** TEXT W PROMO-BLOCKU */
  promoBlockText: string

  /** TEKST PRZYCISKU */
  promoBlockButtonText: string

  /** LINK PROMO BLOCKA => OTWIERANY W NOWYK OKNIE */
  promoBlockLink: string

  /** PADDING-TOP, JEŚLI CHCEMY INNY NIŻ DEFAULT: 50 */
  paddingTop?: number

  /** PADDING-BOTTOM, JEŚLI CHCEMY INNY NIŻ DEFAULT: 50 */
  paddingBottom?: number
}

interface PromoBlockState {}

class PromoBlock extends React.Component<PromoBlockProps,PromoBlockState> {

  constructor(props: PromoBlockProps) {
    super(props);
    this.onPromoBlockTryOutForFreeClick = this.onPromoBlockTryOutForFreeClick.bind(this);
  }

  onPromoBlockTryOutForFreeClick() {
    googleAnalyticsService.trackEvent(GoogleAnalyticsEventType.ClickedCTAButtonAtPromoBlock);
  }

  render() {
    const {promoBlockType,...rest} = this.props;
    switch (promoBlockType) {
      case PromoBlockType.PromoBlockGrayBox:
        return <PromoBlockGrayBox promoBlockButtonOnClick={this.onPromoBlockTryOutForFreeClick} {...rest}/>;
      case PromoBlockType.PromoBlockWhiteBox:
        return <PromoBlockWhiteBox promoBlockButtonOnClick={this.onPromoBlockTryOutForFreeClick} {...rest}/>;
      case PromoBlockType.PromoBlockIconBox:
        return <PromoBlockIconBox promoBlockButtonOnClick={this.onPromoBlockTryOutForFreeClick} {...rest}/>;
      case PromoBlockType.PromoBlockThemeColorBox:
        return <PromoBlockThemeColorBox promoBlockButtonOnClick={this.onPromoBlockTryOutForFreeClick} {...rest}/>;
      case PromoBlockType.PromoBlockFullWidthThemeColorBox:
        return <PromoBlockFullWidthThemeColorBox promoBlockButtonOnClick={this.onPromoBlockTryOutForFreeClick} {...rest}/>;
    }
  }

}

const PromoBlockWrapper = (props: PromoBlockProps) => {
  const {promoBlockType,...rest} = props;
  return (
    <div className="materialize-theme-styles">
      <PromoBlock promoBlockType={promoBlockType} {...rest}/>
    </div>
  )
};

export default PromoBlockWrapper




// WEBPACK FOOTER //
// ./src/layouts/promo-block/promo-block.tsx